<div class="d-flex justify-content-center">
  @if (loading) {
    <ix-spinner></ix-spinner>
  }
</div>
@if (!loading && schema) {
  <ix-key-value-list>
    @for (item of processedChanges; track item.path) {
      @switch (item.change.type) {
        @case ('added') {
          <ix-key-value
            icon="plus"
            [label]="item.label"
            [title]="item.label"
          >
            <ix-typography
              slot="custom-value"
              title="{{
                'battery_pass.private.interaction_status.added'
                  | translate
                    : {
                        value: item.change.newValue,
                        attribute: item.label,
                      }
              }}"
            >{{ item.change.newValue }}
            </ix-typography>
          </ix-key-value>
        }
        @case ('updated') {
          <ix-key-value
            icon="refresh"
            [label]="item.label"
            [title]="item.label"
          >
            <ix-typography
              textColor="alarm"
              slot="custom-value"
              textDecoration="line-through"
              title="{{
                'battery_pass.private.interaction_status.updated'
                  | translate
                    : {
                        newValue: item.change.newValue,
                        oldValue: item.change.oldValue,
                        attribute: item.label,
                      }
              }}"
            >{{ item.change.oldValue }}
            </ix-typography>
            <ix-typography
              slot="custom-value"
              title="{{
                'battery_pass.private.interaction_status.updated'
                  | translate
                    : {
                        newValue: item.change.newValue,
                        oldValue: item.change.oldValue,
                        attribute: item.label,
                      }
              }}"
            >{{ item.change.newValue }}
            </ix-typography>
          </ix-key-value>
        }
        @case ('deleted') {
          <ix-key-value
            icon="trashcan"
            [label]="item.label"
            [title]="item.label"
          >
            <ix-typography
              textColor="alarm"
              slot="custom-value"
              textDecoration="line-through"
              title="{{
                'battery_pass.private.interaction_status.deleted'
                  | translate
                    : {
                        value: item.change.oldValue,
                        attribute: item.label,
                      }
              }}"
            >{{ item.change.oldValue }}
            </ix-typography>
          </ix-key-value>
        }
      }
    }
  </ix-key-value-list>
}
